// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavigationTab__container-dc42e2 {
  display: inline-flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 8px 4px;
  cursor: pointer;
}

.NavigationTab__container-dc42e2:hover,
.NavigationTab__container-dc42e2:focus-visible {
  background-color: var(--base-15);
}

.NavigationTab__container-dc42e2.NavigationTab__active-e13bf5,
.NavigationTab__container-dc42e2.NavigationTab__active-e13bf5:hover,
.NavigationTab__container-dc42e2.NavigationTab__active-e13bf5:focus-visible,
.NavigationTab__container-dc42e2:active {
  background-color: var(--base-20);
}

.NavigationTab__icon-container-ac70b2 {
  position: relative;
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
}

.NavigationTab__icon-d53a2f {
  width: 100%;
  height: 100%;
  fill: var(--base-80);
}

.NavigationTab__label-da43cf {
  color: var(--base-80);
  font: var(--font-caption-4);
  letter-spacing: var(--font-spacing-caption-4);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.NavigationTab__badge-aac534 {
  position: absolute;
  top: -2px;
  right: -2px;
}

.NavigationTab__container-dc42e2:hover .NavigationTab__badge-aac534,
.NavigationTab__container-dc42e2:focus-visible .NavigationTab__badge-aac534 {
  border-color: var(--base-15);
}

.NavigationTab__container-dc42e2.NavigationTab__active-e13bf5 .NavigationTab__badge-aac534,
.NavigationTab__container-dc42e2.NavigationTab__active-e13bf5:hover .NavigationTab__badge-aac534,
.NavigationTab__container-dc42e2.NavigationTab__active-e13bf5:focus-visible .NavigationTab__badge-aac534,
.NavigationTab__container-dc42e2:active .NavigationTab__badge-aac534 {
  border-color: var(--base-20);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SidebarPanelNavigation/NavigationTab/NavigationTab.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;;EAEE,gCAAA;AACF;;AAEA;;;;EAIE,gCAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,qBAAA;EACA,2BAAA;EACA,6CAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AACF;;AAEA;;EAEE,4BAAA;AACF;;AAEA;;;;EAIE,4BAAA;AACF","sourcesContent":[".container {\n  display: inline-flex;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  padding: 8px 4px;\n  cursor: pointer;\n}\n\n.container:hover,\n.container:focus-visible {\n  background-color: var(--base-15);\n}\n\n.container.active,\n.container.active:hover,\n.container.active:focus-visible,\n.container:active {\n  background-color: var(--base-20);\n}\n\n.icon-container {\n  position: relative;\n  width: 24px;\n  height: 24px;\n  margin-bottom: 4px;\n}\n\n.icon {\n  width: 100%;\n  height: 100%;\n  fill: var(--base-80);\n}\n\n.label {\n  color: var(--base-80);\n  font: var(--font-caption-4);\n  letter-spacing: var(--font-spacing-caption-4);\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.badge {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n}\n\n.container:hover .badge,\n.container:focus-visible .badge {\n  border-color: var(--base-15);\n}\n\n.container.active .badge,\n.container.active:hover .badge,\n.container.active:focus-visible .badge,\n.container:active .badge {\n  border-color: var(--base-20);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NavigationTab__container-dc42e2`,
	"active": `NavigationTab__active-e13bf5`,
	"icon-container": `NavigationTab__icon-container-ac70b2`,
	"iconContainer": `NavigationTab__icon-container-ac70b2`,
	"icon": `NavigationTab__icon-d53a2f`,
	"label": `NavigationTab__label-da43cf`,
	"badge": `NavigationTab__badge-aac534`
};
module.exports = ___CSS_LOADER_EXPORT___;
